import * as React from 'react';
import { useSelector } from 'react-redux';
import { BanksList } from '../../components/BanksList';
import { BlockHeader } from '../../components/BlockHeader';
import { ContentWrapper } from '../../components/ContentWrapper';
import { LandingBlock } from '../../components/LandingBlock';
import { NBSP } from '../../constants/symbols';
import { selectBanksList } from '../../selectors/mortgageBanksData';

export const BanksListContainer = () => {
  const banksList = useSelector(selectBanksList);

  return (
    <ContentWrapper>
      <LandingBlock>
        <BlockHeader>Работаем с{NBSP}крупнейшими банками</BlockHeader>
        <BanksList banksList={banksList.mortgage} />
      </LandingBlock>
    </ContentWrapper>
  );
};
